import client from '../client'
import { exportFile } from '../requestDownloadFile'

export default {
  getFinanceSellerBillingsList: data => {
    return client.get('finance/seller/billings/list', { params: data }).then(res => res.data)
  },
  getFinanceSellerBillingsDetail: data => {
    return client.get('finance/seller/billings/detail', { params: data }).then(res => res.data)
  },
  financeSellerBillingsSubmit: data => {
    return client.post('finance/seller/billings/submit', data).then(res => res.data)
  },
  financeSellerBillingsDetailExport: data => {
    return exportFile('finance/seller/billings/detail/export', data.qs, data.fileName)
  },
  financeSellerBillingsDownloadInvoice: data => {
    return client.get('finance/seller/billings/downloadInvoice', { params: data }).then(res => res.data)
  },
  financeSellerBillingsInvoice: data => {
    return client.get('finance/seller/billings/invoice', { params: data }).then(res => res.data)
  },
  financeSellerPaymentPaypalCheckoutOrders: data => {
    return client.post('finance/seller/payment/paypal/checkout/orders', data).then(res => res.data)
  },
  /**
   * 账单支付
   * @param {*} data 
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E6%94%AF%E4%BB%98%E8%AE%A2%E5%8D%95/mergeUsingPOST
   */
  payBillings: data => {
    return client.post('finance/seller/payment/merge', data).then(res => res.data)
  },
  financeSellerPaymentPaypalCapture: data => {
    return client.post('finance/seller/payment/paypal/orders/capture', data).then(res => res.data)
  },
  financeSellerPaymentPaypalOrdersCaptures: data => {
    return client.get(`finance/seller/payment/paypal/orders/captures/${data.paypalCaptureId}`, {}).then(res => res.data)
  },
  financeSellerPaymentAlipayPayment: data => {
    return client.get(`finance/seller/payment/alipay/payment`, { params: data }).then(res => res.data)
  },
  financeSellerPaymentAlipayPaymentAmountWithFees: data => {
    return client.get(`finance/seller/payment/alipay/payment/amountWithFees`, { params: data }).then(res => res.data)
  },

  /**
   * 获取待支付的订单总金额
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E8%B4%A2%E5%8A%A1%E8%B4%A6%E5%8D%95/totalPaymentPendingUsingGET
   */
  financeSellerPaymentTotalPaymentPending: () => {
    return client.get(`finance/seller/billings/total/paymentPending`).then(res => res.data)
  },

  /**
   * 检查是否存在待支付的订单
   * @param {*} data BillingIds(billingsIds: 'xxxx,yyyy,zzzz')
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E6%94%AF%E4%BB%98%E8%AE%A2%E5%8D%95/checkPendingPaymentOrderUsingGET
   */
  checkExistedPendingOrder: data => {
    return client.get(`finance/seller/payment/check/pending/paymentOrder`, { params: data }).then(res => res.data)
  },
  /**
   * 获取支付结果
   * @param {*} requestId 
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E6%94%AF%E4%BB%98%E8%AE%A2%E5%8D%95/mergeCheckOrderResultUsingPOST
   */
  getPayResult: requestId => {
    return client.get(`finance/seller/payment/merge/check/orderResult?requestId=${requestId}`).then(res => res.data)
  },
  /**
   * 导出报告
   * @param {*} data 
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E6%94%AF%E4%BB%98%E8%AE%A2%E5%8D%95/reportExportUsingPOST
   */
  exportReport: data => {
    return exportFile('finance/seller/billings/report/export', data.qs, data.fileName)
  },
  /**
   * 导出报告
   * @param {*} data 
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E6%94%AF%E4%BB%98%E8%AE%A2%E5%8D%95/manualDetailsUsingGET
   */
  getManualAdjustmentDetails: data => {
    return client.get(`finance/seller/billings/manual-details`, { params: data }).then(res => res.data)
  },
  // 银行卡支付宝绑定
  financeSellerBankBindStart: data => {
    return client.post('finance/seller/bank/bind/start', data).then(res => res.data)
  },
  // 根据bind-request-id查询信息
  financeSellerBankBindCheck: data => {
    return client.get('finance/seller/bank/instrument/by-bind-request-id', { params: data }).then(res => res.data)
  },
  // 获取银行卡列表
  financeSellerBankInstrumentList: data => {
    return client.get('finance/seller/bank/instrument/list', { params: data }).then(res => res.data)
  },
  // 解绑
  financeSellerBankInstrumentUnbind: data => {
    return client.put(`finance/seller/bank/unbind?bindId=${data.bindId}`, data).then(res => res.data)
  },
  // 自动支付交易记录
  financeSellerBankAutoPaymentTransactionList: data => {
    return client.get('finance/seller/payment/autoDebit/records', { params: data }).then(res => res.data)
  },
  // 完成支付绑定
  financeSellerRegistrationCompletePaymentBinding: data => {
    return client.post('seller/registration/complete-payment-binding', data).then(res => res.data)
  },
  /**
   * 获取未支付的负数账单
   * @param {*} data 
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E6%94%AF%E4%BB%98%E8%AE%A2%E5%8D%95/notPaidNegativeUsingGET
   */
  financeSellerBillingsNotPaidNegative: data => {
    return client.get('finance/seller/billings/notPaid/negative', { params: data }).then(res => res.data)
  },
}